import React from 'react';
import { Redirect } from 'react-router';

interface RedirectToLoginProps {}

const RedirectToLogin: React.FC<RedirectToLoginProps> = props => {
  return <Redirect to="/auth/login" />
}

export default RedirectToLogin;